import { createRouter, createWebHistory } from "vue-router";

import MisCursos from "../views/Dahsboard/MisCursos.vue";
import Leccion from "../views/Dahsboard/Leccion.vue";
import Certificados from "../views/Dahsboard/Certificados.vue";
import PerfilUsuario from "../views/Dahsboard/PerfilUsuario.vue";

//Marcas
import Login from "../views/Pages/Login.vue";
import Inicio from "../views/Dahsboard/Inicio.vue";
import Calendario from "../views/Dahsboard/Calendario.vue";
import Modulos from "../views/Dahsboard/Modulo.vue";
import Soporte from "../views/Dahsboard/Soporte.vue";
import Examen from "../views/Dahsboard/Examen.vue";
import CertificadosPorModulo from "../views/Dahsboard/CertificadosPorModulo.vue";
import Recuperar from "../views/Pages/Recuperar.vue";
import VerificarCertificado from "../views/Pages/VerificarCertificado.vue";
import Notificaciones from "../views/Dahsboard/Notificaciones.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/inicio",
  },

  {
    path: "/certificado/:id_certificado?",
    name: "VerificarCertificado",
    component: VerificarCertificado,
    meta: {
      title: "",
      auth: false,
    },
  },

  {
    path: "/inicio",
    name: "Inicio",
    component: Inicio,
    meta: {
      title: "Inicio - Mi Aula Virtual",
      auth: true,
    },
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "Inicio de Sesión",
      auth: false,
    },
  },
  {
    path: "/restablecer/:idusuario",
    name: "Recuperar",
    component: Recuperar,
    meta: {
      title: "Recuperar Contraseña",
      auth: false,
    },
  },

  {
    path: "/miscursos",
    name: "Mis Cursos",
    component: MisCursos,
    meta: {
      title: "Mis Cursos",
      auth: true,
    },
  },
  {
    path: "/miscursos/:id_curso/modulos",
    name: "Modulos",
    component: Modulos,
    meta: {
      title: "Modulos",
      auth: true,
    },
  },

  {
    path: "/notificaciones",
    name: "Notificaciones",
    component: Notificaciones,
    meta: {
      title: "Notificaciones",
      auth: true,
    },
  },
  {
    path: "/examen/:tipo/:idtipo",
    name: "Examen",
    component: Examen,
    meta: {
      title: "Examen",
      auth: true,
    },
  },

  {
    path: "/calendario",
    name: "Calendario",
    component: Calendario,
    meta: {
      title: "Calendario",
      auth: false,
    },
  },

  {
    path: "/perfil",
    name: "PerfilUsuario",
    component: PerfilUsuario,
    meta: {
      title: "Perfil de Usuario",
      auth: true,
    },
  },

  {
    path: "/miscursos/:idcurso/modulos/:idmodulo/leccion/:idleccion",
    name: "Leccion",
    component: Leccion,
    meta: {
      title: "Leccion",
      auth: true,
    },
  },

  {
    path: "/miscertificados",
    name: "Mis Certificados",
    component: Certificados,
    meta: {
      title: "Certificados",
      auth: true,
    },
  },

  {
    path: "/certificado-modulo/:id_curso",
    name: "CertificadoporModulo",
    component: CertificadosPorModulo,
    meta: {
      title: "Certificados por Modulo",
      auth: true,
    },
  },

  {
    path: "/soporte",
    name: "Soporte",
    component: Soporte,
    meta: {
      title: "Soporte",
      auth: true,
    },
  },
  /* {
        path: '/:pathMatch(.*)*',
        redirect: '/plataformas',
    }*/
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem("authToken");
  const user = JSON.parse(localStorage.getItem("user"));

  if (to.matched.some((record) => record.meta.auth)) {
    if (!isAuthenticated) {
      next({ name: "Login" });
    } else if (!user) {
      next({ name: "Login" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
